<template>
  <v-container fluid>
    <v-card flat>
      <v-toolbar color="#f0e633"
                 dark
                 extended
                 flat
      >
      </v-toolbar>

      <v-card class="mx-auto"
              max-width="1200"
              style="margin-top: -64px;"
      >
        <v-toolbar flat>
          <v-toolbar-title class="black--text">Clientes</v-toolbar-title>

          <v-spacer></v-spacer>

          <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Buscar.."
              single-line
              hide-details
              class="mr-2"
          ></v-text-field>

          <v-btn class="mr-1"
                 dark
                 color="green"
                 @click.stop="showAddCustomerModal()"
          >
            <v-icon>mdi-plus</v-icon>
            Nuevo Cliente
          </v-btn>

          <download-excel class="mr-1 white--text d-print-none v-btn v-btn--contained theme--light v-size--default black cursor-pointer"
                          :data="customers"
                          :fields="headers_export"
                          worksheet="Clientes Festy POS"
                          name="customersPOS.xls"
          >
            <v-icon left
                    color="white"
            >mdi-microsoft-excel
            </v-icon>
            Descargar en Excel
          </download-excel>

          <!--<v-btn color="primary"
                 dark
                 @click.stop="showImportCustomersModal()"
          >
            <v-icon left>mdi-file-import</v-icon>
            Importar Clientes
          </v-btn>-->

        </v-toolbar>

        <v-divider></v-divider>

        <v-card-text>
          <v-data-table :loading="loading.customers"
                        loading-text="Cargando... Por favor espere"
                        :headers="headers"
                        :items="customers"
                        :search="search"
                        :footer-props="pagination"
                        class="elevation-1"
                        sort-by="name"
          >

            <template v-slot:item.createdAt="{ item }">
              {{ formatDate(item.createdAt) }}
            </template>

            <template v-slot:item.address="{ item }">
              {{ addDotsToEndOfString(item.address) }}
            </template>

            <template v-slot:item.action="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon small
                          class="mr-2"
                          v-bind="attrs"
                          v-on="on"
                          color="primary"
                          @click.stop="showDetailsCustomerModal(item)"
                  >
                    mdi-information
                  </v-icon>
                </template>
                <span>Ver detalles</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon small
                          class="mr-2"
                          v-bind="attrs"
                          v-on="on"
                          color="teal"
                          @click.stop="showEditCustomerModal(item)"
                  >
                    mdi-pencil
                  </v-icon>
                </template>
                <span>Editar</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon small
                          class="mr-2"
                          v-bind="attrs"
                          v-on="on"
                          color="red"
                          @click.stop="showDeleteCustomerModal(item)"
                  >
                    mdi-delete
                  </v-icon>
                </template>
                <span>Eliminar</span>
              </v-tooltip>
            </template>

            <template v-slot:no-data>
              <v-btn color="primary"
                     @click="fetchCustomers()"
              >RECARGAR
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-card>

    <!-- START MODAL DETAILS CUSTOMERS -->
    <v-dialog
        v-model="modal.showDetailsCustomer"
        width="500"
        scrollable
    >
      <v-card>
        <v-toolbar color="transparent">

          <v-btn icon
                 color="black"
                 @click="hideDetailsCustomerModal()"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>

          <v-toolbar-title>Detalles del Cliente</v-toolbar-title>
        </v-toolbar>

        <v-card-text>
          <v-row align="center"
                 justify="center"
          >

            <v-col cols="12">
              <div class="body-1 text-wrap mb-3">
                <v-icon>mdi-account</v-icon>
                <strong class="font-weight-bold black--text">Nombre:</strong> {{ detailsCustomer.name }}
              </div>
              <div class="body-1 text-wrap mb-3">
                <v-icon>mdi-map-marker</v-icon>
                <strong class="font-weight-bold black--text">Dirección:</strong> {{ detailsCustomer.address }}
              </div>
              <div class="body-1 text-wrap mb-3">
                <v-icon>mdi-cellphone</v-icon>
                <strong class="font-weight-bold black--text">Teléfono:</strong> {{ detailsCustomer.phone }}
              </div>
              <div class="body-1 text-wrap mb-3">
                <v-icon>mdi-calendar</v-icon>
                <strong class="font-weight-bold black--text">Fecha de Creación:</strong>
                {{ formatDate(detailsCustomer.createdAt) }}
              </div>
              <div class="body-1 text-wrap mb-3">
                <v-icon>mdi-tag-text</v-icon>
                <strong class="font-weight-bold black--text">Tags:</strong>
                {{ joinArrayBySeparator(detailsCustomer.tags) }}
              </div>
            </v-col>

          </v-row>

        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- END MODAL DETAILS CUSTOMER -->

    <!-- START MODAL EDIT CUSTOMERS -->
    <v-dialog
        v-model="modal.showEditCustomer"
        width="500"
        persistent
    >
      <v-card>
        <v-toolbar color="transparent">

          <v-btn icon
                 color="black"
                 @click="hideEditCustomerModal()"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>

          <v-toolbar-title>Editar Cliente - {{ editCustomer.name }}</v-toolbar-title>
        </v-toolbar>

        <customer-form :merchant-id="getMerchantId()"
                       :customer="editCustomer"
                       is-updating
                       v-on:customer:saved="addOrEditCustomerSaved($event)"
                       v-on:customer:canceled="hideEditCustomerModal()"
        />
      </v-card>
    </v-dialog>
    <!-- END MODAL EDIT CUSTOMER -->

    <!-- START MODAL ADD CUSTOMER -->
    <v-dialog v-model="modal.showAddCustomer"
              width="500"
              persistent
    >
      <v-card>
        <v-toolbar color="transparent">

          <v-btn icon
                 color="black"
                 @click="hideAddCustomerModal"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>

          <v-toolbar-title>Agregar Nuevo Cliente</v-toolbar-title>
        </v-toolbar>

        <customer-form :merchant-id="getMerchantId()"
                       v-on:customer:saved="addOrEditCustomerSaved($event)"
                       v-on:customer:canceled="hideAddCustomerModal()"
        />
      </v-card>
    </v-dialog>

    <!-- START MODAL DELETE -->
    <v-dialog
        v-model="modal.showDeleteCustomer"
        width="320"
        persistent
    >
      <v-card>
        <v-card-title class="headline black--text">
          Confirmar
        </v-card-title>

        <v-card-text class="red--text body-1">
          ¿Seguro que desea eliminar a <b>{{ deleteCustomer.name }}</b> ?
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
              dark
              @click="hideDeleteCustomerModal()"
          >
            No
          </v-btn>

          <v-btn
              dark
              color="red"
              :loading="sending.deleteCustomer"
              @click="removeCustomer()"
          >
            Si
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- END MODAL DELETE -->

    <!-- START MODAL IMPORT CUSTOMERS -->
    <v-dialog
        v-model="modal.showImportCustomers"
        width="1200"
        scrollable
        persistent
    >
      <v-card>
        <v-card-title
            class="title transparent"
            primary-title
        >
          <span class="text-capitalize"> Importar clientes CSV </span>
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text>
          <div class="mb-2"></div>
          <v-row dense>
            <v-col cols="12">
              <!--<vue-csv-import
                  v-model="csvCustomers"
                  url="#"
                  :map-fields="['name', 'phone', 'address', 'tags']"
                  tableClass="v-data-table theme--light"
                  tableSelectClass="v-input__control h100 display-select"
                  :headers="true"
                  :autoMatchFields="true"
              >
                <template slot="error">
                  <p class="red--text"><strong>El tipo de archivo es invalido. </strong></p>
                </template>

                <template slot="thead">
                  <tr style="border: 1px solid black;">
                    <th style="border: 1px solid black;">Columnas del sistema</th>
                    <th style="border: 1px solid black;">Columnas del archivo CSV</th>
                  </tr>
                </template>

                <template slot="next"
                          slot-scope="{load}"
                >
                  <v-btn
                      class="mt-5 mb-5 white--text"
                      color="black"
                      @click.prevent="load"
                  >
                    <v-icon class="mr-1">mdi-cloud-upload</v-icon>
                    Cargar archivo CSV
                  </v-btn>
                  <v-icon>mdi-numeric-1-circle-outline</v-icon>
                  <p class="mt-3 mb-3"><strong> En la siguiente tabla, compruebe que las columnas de su archivo CSV
                                                estén en concordancia con las columnas de la base de datos. </strong>
                  </p>
                </template>

                <template slot="submit"
                          slot-scope="{submit}"
                >
                  <v-btn
                      class="mt-5 mb-5 white--text"
                      color="black"
                      @click.prevent="submit"
                  >
                    <v-icon class="mr-1">mdi-table-eye</v-icon>
                    Mostrar tabla de datos
                  </v-btn>
                  <v-icon>mdi-numeric-2-circle-outline</v-icon>
                </template>
              </vue-csv-import>-->
            </v-col>

            <v-col cols="12"
                   v-if="hasCsvCustomers()"
            >

              <v-data-table
                  :headers="headersCsv"
                  :items="csvCustomers"
                  :footer-props="pagination"
                  class="elevation-1"
              >
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn
              color="primary"
              outlined
              @click.stop="hideImportCustomersModal()"
          >
            <v-icon left>mdi-close</v-icon>
            Cerrar
          </v-btn>

          <v-spacer></v-spacer>

          <v-icon>mdi-numeric-3-circle-outline</v-icon>

          <!--<v-btn color="success"
                 outlined
                 :loading="sending.importCustomers"
                 @click="importCustomers()"
          >
            <v-icon left>mdi-database-import</v-icon>
            Importar clientes
          </v-btn>-->
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- END MODAL IMPORT CUSTOMERS -->

  </v-container>
</template>

<script>
import Parse from "parse";
import JsonExcel from 'vue-json-excel'
import CustomerForm from "@/components/forms/CustomerForm"
//import {VueCsvImport} from 'vue-csv-import'

export default {

  components: {
    CustomerForm,
    'download-excel': JsonExcel,
    //VueCsvImport
  },

  data() {
    return {
      customers: [],
      headers: [
        {text: 'Nombre', value: 'name'},
        {text: 'Celular', value: 'phone'},
        {text: 'Dirección', value: 'address'},
        {text: 'Tags', value: 'tags'},
        {text: 'Fecha', value: 'createdAt'},
        {text: 'Acciones', value: 'action', sortable: false},
      ],
      headers_export: {
        'ID': 'id',
        'Nombre': 'name',
        'Celular': 'phone',
        'Dirección': 'address',
        'Tags': 'tags',
        'Fecha creación': {
          field: 'createdAt',
          callback: (value) => {
            let startDate = value.toLocaleString()
            return `${startDate}`;
          }
        }
      },
      headersCsv: [
        {text: 'Nombre', value: 'name'},
        {text: 'Celular', value: 'phone'},
        {text: 'Direccion', value: 'address'},
        {text: 'Etiquetas', value: 'tags'},
      ],
      loading: {
        customers: true,
      },
      sending: {
        customers: false,
        deleteCustomer: false,
        importCustomers: false
      },
      modal: {
        showDetailsCustomer: false,
        showEditCustomer: false,
        showAddCustomer: false,
        showDeleteCustomer: false,
        showImportCustomers: false
      },
      detailsCustomer: {},
      deleteCustomer: {},
      csvCustomers: null,
      editCustomer: {
        name: '',
        phone: '',
        address: '',
        notes: '',
        tags: []
      },
      pagination: {
        "items-per-page-options": [50, 60, 70, 100, -1]
      },
      search: "",
      companie: ''
    };
  },

  mounted() {
    this.fetchCustomers();
  },

  methods: {
    getMerchantId() {
      return this.$route.params.store_id
    },

    hasCsvCustomers() {
      return this.csvCustomers !== null
    },

    showDetailsCustomerModal(customer) {
      this.detailsCustomer = customer
      this.modal.showDetailsCustomer = true
    },

    hideDetailsCustomerModal() {
      this.modal.showDetailsCustomer = false
    },

    showEditCustomerModal(customer) {
      this.fillEditCustomer(customer)
      this.modal.showEditCustomer = true
    },

    hideEditCustomerModal() {
      this.modal.showEditCustomer = false
    },

    showAddCustomerModal() {
      this.modal.showAddCustomer = true
    },

    hideAddCustomerModal() {
      this.modal.showAddCustomer = false
    },

    showDeleteCustomerModal(customer) {
      this.deleteCustomer = customer
      this.modal.showDeleteCustomer = true
    },

    hideDeleteCustomerModal() {
      this.modal.showDeleteCustomer = false
    },

    showImportCustomersModal() {
      this.modal.showImportCustomers = true
    },

    hideImportCustomersModal() {
      this.modal.showImportCustomers = false
    },

    fillEditCustomer(customer) {
      Object.assign(this.editCustomer, customer)
    },

    joinArrayBySeparator(array, separator = ', ') {
      if (array === undefined) {
        return ''
      }

      return array.join(separator)
    },

    fetchCustomers() {
      let params = {
        id: this.$route.params.store_id
      }

      this.runParseCloud('getMyCustomersBO', params)
          .then(response => this.customers = this.transformCustomersResponseToCustomers(response))
          .catch(error => this.showErrorMessage('Error', error.message))
          .finally(() => this.setLoadingCustomersAsFalse())
    },

    setLoadingCustomersAsFalse() {
      this.loading.customers = false
    },

    findCustomerIndexById(customerId) {
      return this.customers.findIndex(value => value.id === customerId)
    },

    addOrEditCustomerSaved(customer) {
      let customerIndex = this.findCustomerIndexById(customer.id)

      if (customerIndex === -1) {
        this.customers.push(customer)
        this.hideAddCustomerModal()
      } else {
        Object.assign(this.customers[customerIndex], customer)
        this.hideEditCustomerModal()
      }
    },

    addDotsToEndOfString(string, limit = 50) {
      if (string.length > limit) {
        return string.slice(0, limit) + '...'
      }

      return string
    },

    transformCustomersResponseToCustomers(response) {
      return response.map(value => {
        return {
          id: value.id,
          name: value.attributes.name,
          phone: value.attributes.phone,
          address: value.attributes.address,
          notes: value.attributes.notes,
          tags: value.attributes.tags,
          createdAt: value.attributes.createdAt
        }
      })
    },

    removeCustomer() {
      this.setSendingDeleteAsTrue()

      this.runParseCloud('deleteCustomerST', {store: this.getMerchantId(), customer: this.deleteCustomer.id})
          .then(() => {
            this.removeCustomerByIndex(this.findCustomerIndexById(this.deleteCustomer.id))
            this.hideDeleteCustomerModal()
          })
          .catch(error => this.showErrorMessage('Error', error.message))
          .finally(() => this.setSendingDeleteAsFalse())
    },

    removeCustomerByIndex(index) {
      this.customers.splice(index, 1)
    },

    importCustomers() {
      this.setSendingImportCustomersAsTrue()
      this.createCustomerForEachCSVCustomer()
      this.hideImportCustomersModal()
      this.setSendingImportCustomersAsFalse()
      this.resetCsvImportCustomers()
    },

    splitArrayBySeparator(string, separator = ',') {
      return string.split(separator)
    },

    createCustomerForEachCSVCustomer() {
      this.csvCustomers.forEach(item => {
        let params = {
          name: item.name,
          address: item.address,
          phone: item.phone,
          notes: '',
          store: this.getMerchantId(),
          tags: JSON.stringify(this.splitArrayBySeparator(item.tags))
        }

        this.runParseCloud('createCustomerST', params)
            .then(response => {
              this.addOrEditCustomerSaved({
                id: response.id,
                name: response.attributes.name,
                address: response.attributes.address,
                phone: response.attributes.phone,
                notes: response.attributes.notes,
                tags: response.attributes.tags,
              })
            })
            .catch(error => {
              this.showErrorMessage('Error', error.message)
              this.hideImportCustomersModal()
              this.setSendingImportCustomersAsFalse()
              this.resetCsvImportCustomers()
            })
      })
    },

    resetCsvImportCustomers() {
      this.csvCustomers = null
    },

    setSendingDeleteAsTrue() {
      this.sending.deleteCustomer = true
    },

    setSendingDeleteAsFalse() {
      this.sending.deleteCustomer = false
    },

    setSendingImportCustomersAsTrue() {
      this.sending.importCustomers = true
    },

    setSendingImportCustomersAsFalse() {
      this.sending.importCustomers = false
    },

    formatDate(date, format = 'lll') {
      return this.$moment(date).format(format)
    },

    runParseCloud(name, params, options = {}) {
      return Parse.Cloud.run(name, params, options)
    },

    showErrorMessage(title, message) {
      this.$snotify.error(message, title, {timeout: 4000, preventDuplicates: true});
    }
  }
};
</script>

<style scope
       lang="scss"
>
.cursor-pointer {
  cursor: pointer;

  &:hover {
    opacity: 0.9;
  }
}
</style>